
export default {
  components: {
    OrganicModal: () => import('~/components/Molecules/Organic/Modal/Modal.vue'),
    hotHeroWithBackground: () => import('~/components/Organisms/HeroWithBackground/HeroWithBackground.vue'),
    hotBusinessNeeds: () => import('~/components/Organisms/BusinessNeeds/BusinessNeeds.vue'),
    hotContentSection: () => import('~/components/Organisms/ContentSection/ContentSection.vue'),
    hotYouNeed: () => import('~/components/Organisms/YouNeed/YouNeed.vue'),
    hotEightAdvantages: () => import('~/components/Organisms/EightAdvantages/EightAdvantages.vue'),
    hotAffiliatesAccordionToTab: () =>
      import('~/components/Organisms/Affiliates/AffiliatesAccordionToTab/AffiliatesAccordionToTab.vue'),
    hotSocialProof: () => import('~/components/Organisms/SocialProof/SocialProof.vue'),
    hotAffiliatesSolutions: () =>
      import('~/components/Organisms/Affiliates/AffiliatesSolutions/AffiliatesSolutions.vue'),
    hotAffiliatesBannerFooter: () =>
      import('~/components/Organisms/Affiliates/AffiliatesBannerFooter/AffiliatesBannerFooter.vue'),
  },

  computed: {
    isPortuguese() {
      return Boolean(['pt-br'].includes(this.$i18n.locale))
    },
  },
}
